import { CustomSlideType, QuestionSlideType, SlideType } from '@llx/common';
import { Dispatch, SetStateAction, useCallback } from 'react';

type Args = {
  slide: QuestionSlideType | CustomSlideType;
  currentSelectedAnswers: string[];
  setCurrentSelectedAnswers: Dispatch<SetStateAction<string[]>>;
};

export function useAnswersSelectingLogic({
  slide,
  currentSelectedAnswers,
  setCurrentSelectedAnswers,
}: Args) {
  const onSelectableAnswerClick = useCallback(
    (answerID: string) => {
      switch (slide.type) {
        case SlideType.QUESTION_SINGLE:
          if (currentSelectedAnswers.includes(answerID)) {
            setCurrentSelectedAnswers([]);
            return;
          }
          //if it's not selected, we add it
          setCurrentSelectedAnswers([answerID]);
          break;
        case SlideType.QUESTION_MULTIPLE:
          //if it's already selected, we remove it
          if (currentSelectedAnswers.includes(answerID)) {
            setCurrentSelectedAnswers((prev) => prev.filter((index) => index !== answerID));
            return;
          }
          //if it's not selected, we add it
          if (currentSelectedAnswers.length < slide.maxChoices)
            setCurrentSelectedAnswers((prev) => [...prev, answerID]);
          break;
        case SlideType.QUESTION_MULTIPLE_ORDERED:
          //if it's already selected, we remove it and remove all the following answers
          if (currentSelectedAnswers.includes(answerID)) {
            setCurrentSelectedAnswers((prev) => {
              const indexInArray = prev.indexOf(answerID);
              return prev.filter((_, idx) => idx < indexInArray);
            });
            return;
          }
          //if it's not selected, we add it
          if (currentSelectedAnswers.length < slide.correctOrderIds.length)
            setCurrentSelectedAnswers((prev) => [...prev, answerID]);
          break;
        case SlideType.CUSTOM:
          break;
        default: {
          const _exhaustiveCheck: never = slide;
          console.error('Unhandled slide type in useAnswersSelectingLogic:', slide);
          throw new Error(`Unhandled slide type`);
        }
      }
    },
    [currentSelectedAnswers]
  );

  return {
    onSelectableAnswerClick,
  };
}
